export enum CounterpartyEmployeeTrustStatus {
	ABSENT = "Absent",
	REVIEW = "Review",
	ACTIVE = "Active",
	REJECTED = "Rejected",
	OUTDATED = "Outdated"
}
